const thTH = {
  'modal.close': 'ปิด',
  'session_expired.title': 'เซสชันหมดอายุแล้ว',
  'tokenizationForm.payment-terms.text1':
    'ฉันอนุญาตให้ Flywire จัดเก็บและเรียกเก็บเงินจากบัตรเดบิต/เครดิตของฉันโดยอัตโนมัติในนามของ {{recipientName}} ฉันได้อ่าน เข้าใจ และยอมรับ',
  'tokenizationForm.general-terms.link2': 'นโยบายความเป็นส่วนตัว',
  'tokenizationForm.general-terms.link-joint': ' และ ',
  'tokenizationForm.general-terms.link1': 'ข้อกำหนดการใช้งาน',
  'tokenizationForm.payment-terms.link': 'ข้อกำหนดการใช้งานของ Flywire สำหรับการชำระเงินอัตโนมัติ',
  'tokenizationForm.labels.cvvTooltip': 'เลข 3 หลักด้านหลังบัตร หรือเลข 4 หลักด้านหน้าบัตร',
  'tokenizationForm.labels.cvv': 'CVV',
  'tokenizationForm.labels.expiryDate': 'วันหมดอายุ (MM/YY)',
  'tokenizationForm.labels.cardNumber': 'หมายเลขบัตร',
  'tokenizationForm.labels.phone': 'หมายเลขโทรศัพท์',
  'tokenizationForm.labels.upopPhone': 'โปรดกรอกหมายเลขโทรศัพท์มือถือที่ผูกกับบัตรธนาคารใบนี้',
  'tokenizationForm.labels.zip': 'รหัสไปรษณีย์',
  'tokenizationForm.labels.address': 'ที่อยู่',
  'cardsForm.labels.state': 'รัฐ',
  'tokenizationForm.labels.country': 'ประเทศหรือภูมิภาค',
  'tokenizationForm.labels.city': 'เมือง',
  'tokenizationForm.labels.email': 'อีเมล',
  'tokenizationForm.labels.lastName': 'นามสกุล',
  'tokenizationForm.labels.firstName': 'ชื่อ',
  'cardsForm.title': 'ข้อมูลผู้ถือบัตร',
  'success.title': 'เงินของคุณอยู่ระหว่างการโอน',
  'success.title.info':
    'โปรดรอ 2-3 วันทำการเพื่อให้เงินไปถึง\nคุณจะได้รับอีเมลเมื่อส่งมอบเงินเรียบร้อยแล้ว',
  'bankAccountForm.hints.generic': 'ตัวอย่าง: {{label}}',
  'bankAccountForm.hints.account_number': 'หมายเลขบัญชีต้องมีความยาวระหว่าง 1 ถึง 17 ตัวอักษร',
  'bankAccountForm.hints.routing_number': 'หมายเลข Routing ต้องมี 9 หลัก',
  'bankAccountForm.labels.accountZipCode': 'รหัสไปรษณีย์',
  'bankAccountForm.labels.accountIban': 'IBAN',
  'bankAccountForm.labels.accountBicCode': 'รหัส BIC',
  'bankAccountForm.labels.accountNumber': 'หมายเลขบัญชี',
  'bankAccountForm.labels.accountSortCode': 'Sort code',
  'bankAccountForm.labels.accountRoutingNumber': 'หมายเลข Routing',
  'bankAccountForm.labels.accountType': 'ประเภทบัญชี',
  'bankAccountForm.labels.eftProviderWidnow':
    'คุณจะถูกนำไปยังแพลตฟอร์มประมวลผลของพันธมิตรเพื่อทำการชำระเงินนี้ให้เสร็จสมบูรณ์ เมื่อเสร็จแล้วคุณจะถูกเปลี่ยนเส้นทางกลับมายังหน้านี้อีกครั้ง',
  'bankAccountForm.labels.termsFlywire':
    "ฉันได้อ่าน เข้าใจ และยอมรับ<a class='fw-underline fw-text-primary-600' href='https://www.flywire.com/terms/' target='_blank' rel='noopener noreferrer' data-testid='termsOfUseLink'>ข้อกำหนดการใช้งาน</a>และ<a class='fw-underline fw-text-primary-600' href='https://www.flywire.com/privacy/' target='_blank' data-testid='privacyPolicyLink' rel='noopener noreferrer'>นโยบายความเป็นส่วนตัว</a>ของ Flywire",
  'bankAccountForm.labels.termsDirectDebit':
    'ฉันยืนยันว่าฉันเป็นเจ้าของบัญชีนี้ และเป็นผู้มีอำนาจลงนามเพียงคนเดียวที่จำเป็นในการอนุมัติการหักบัญชีโดยตรงนี้',
  'bankAccountForm.labels.termsEft':
    "ฉันได้อ่าน เข้าใจ และยอมรับ<a class='fw-underline fw-text-primary-600' href='https://opu.myonplanu.com/pdf/pad-agreement.pdf' target='_blank' rel='noopener noreferrer'>ข้อตกลงการหักบัญชีล่วงหน้า (Pre-Authorized Debit)</a>",
  'bankAccountForm.labels.city': 'เมือง',
  'bankAccountForm.labels.country': 'ประเทศหรือภูมิภาค',
  'bankAccountForm.labels.selectCountry': 'เลือกประเทศหรือภูมิภาค',
  'bankAccountForm.title': 'ข้อมูลเจ้าของบัญชี',
  'failure.tryAgain': 'ลองอีกครั้ง',
  'failure.title': 'ธุรกรรมไม่สำเร็จ',
  'failure.connectivity.message': 'การดำเนินการไม่สำเร็จ ซึ่งอาจเกิดจากปัญหาการเชื่อมต่อ',
  'failure.message':
    'ธุรกรรมไม่สำเร็จ ซึ่งอาจเกิดจากปัญหาการเชื่อมต่อ โปรดลองอีกครั้ง หากปัญหายังคงอยู่ โปรดลองใช้วิธีการชำระเงินอื่นหรือติดต่อธนาคารของคุณ',
  'sessionExpired.text': 'เซสชันหมดอายุแล้ว',
  'LoadingError.title': 'เกิดข้อผิดพลาดบางอย่าง',
  'LoadingError.message': 'เกิดข้อผิดพลาดในการโหลดแบบฟอร์ม',
  'tokenizationForm.errors.noPaymentOptionsAvailable':
    'ไม่มีตัวเลือกการชำระเงินสำหรับประเทศ/ภูมิภาคที่เลือก',
  'offerError.noOptions.card': 'ไม่รองรับบัตรประเภทที่เลือก โปรดใช้บัตรประเภทอื่น',
  'offerError.noOptions.bank': 'ไม่รองรับบัญชีธนาคารที่เลือก โปรดใช้บัญชีธนาคารอื่น',
  'offerError.noOptions.other': 'ไม่รองรับวิธีการชำระเงินที่เลือก โปรดใช้วิธีการชำระเงินอื่น',
  'bankAccountForm.labels.accountHolderType.personal': 'บัญชีส่วนบุคคล',
  'bankAccountForm.labels.accountHolderType.business': 'บัญชีธุรกิจ',
  'bankAccountForm.labels.name': 'ชื่อ',
  'bankAccountForm.labels.businessName': 'ชื่อธุรกิจ',
  'bankAccountForm.labels.surname': 'นามสกุล',
  'bankAccountForm.labels.phone': 'หมายเลขโทรศัพท์',
  'bankAccountForm.labels.email': 'อีเมล',
  'bankAccountForm.labels.zip': 'รหัสไปรษณีย์',
  'bankAccountForm.labels.accountAddress': 'ที่อยู่',
  'bankAccountForm.labels.address': 'ที่อยู่',
  'bankAccountForm.errors.dynamicFields': '{{field}} ไม่ถูกต้อง',
  'bankAccountForm.labels.saveButton': 'บันทึก',
  'bankAccountForm.labels.nextButton': 'ถัดไป',
  'bankAccountForm.labels.payButton': 'ชำระเงิน',
  'bankAccountForm.errors.cardNumber': 'หมายเลขบัตรไม่ถูกต้อง',
  'tokenizationForm.errors.cardNumber': 'หมายเลขบัตรไม่ถูกต้อง',
  'tokenizationForm.errors.cvv': 'หมายเลข CVV ไม่ถูกต้อง',
  'bankAccountForm.errors.cvv': 'หมายเลข CVV ไม่ถูกต้อง',
  'tokenizationForm.errors.unsupportedCardTypes': 'รองรับเฉพาะ {{acceptedCardsList}} เท่านั้น',
  'tokenizationForm.errors.unsupportedCardType': 'รองรับเฉพาะ {{acceptedCard}} เท่านั้น',
  'tokenizationForm.errors.cardType.and': 'และ',
  'tokenizationForm.errors.name': 'ชื่อไม่ถูกต้อง',
  'tokenizationForm.errors.email': 'อีเมลไม่ถูกต้อง',
  'tokenizationForm.errors.country': 'ประเทศหรือภูมิภาคไม่ถูกต้อง',
  'tokenizationForm.errors.state': 'รัฐไม่ถูกต้อง',
  'tokenizationForm.errors.city': 'เมืองไม่ถูกต้อง',
  'tokenizationForm.errors.address': 'ที่อยู่ไม่ถูกต้อง',
  'tokenizationForm.errors.addressIsPoBox': 'เราไม่รับตู้ไปรษณีย์ในช่องที่อยู่',
  'tokenizationForm.errors.onlyLetterOrNumbers': 'ใช้ได้เฉพาะอักขระ A-Z และ 0-9 เท่านั้น',
  'tokenizationForm.errors.onlyLetterOrNumbersOrSymbol':
    'ใช้ได้เฉพาะอักขระ A-Z, 0-9 และ "/, -" เท่านั้น',
  'tokenizationForm.errors.zip': 'รหัสไปรษณีย์ไม่ถูกต้อง',
  'tokenizationForm.errors.expiryDate': 'วันหมดอายุไม่ถูกต้อง',
  'bankAccountForm.errors.expiryDate': 'วันหมดอายุไม่ถูกต้อง',
  'tokenizationForm.errors.surname': 'นามสกุลไม่ถูกต้อง',
  'tokenizationForm.errors.phone': 'หมายเลขโทรศัพท์ไม่ถูกต้อง',
  'tokenizationForm.errors.length': 'ข้อความยาวเกินไป (สูงสุด 256 ตัวอักษร)',
  'tokenizationForm.errors.required.field': 'จำเป็นต้องกรอก',
  'bankAccountForm.errors.name': 'ชื่อไม่ถูกต้อง',
  'bankAccountForm.errors.name.maxSizeExceeded': 'ชื่อยาวเกินไป (สูงสุด 140 ตัวอักษร)',
  'form.errors.name.maxSizeExceeded': 'ชื่อยาวเกินไป (สูงสุด {{limit}} ตัวอักษร)',
  'form.errors.surname.maxSizeExceeded': 'นามสกุลยาวเกินไป (สูงสุด {{limit}} ตัวอักษร)',
  'form.errors.business_name.maxSizeExceeded': 'ชื่อธุรกิจยาวเกินไป (สูงสุด {{limit}} ตัวอักษร)',
  'form.errors.city.maxSizeExceeded': 'ชื่อเมืองยาวเกินไป (สูงสุด {{limit}} ตัวอักษร)',
  'form.errors.address.maxSizeExceeded': 'ที่อยู่ยาวเกินไป (สูงสุด {{limit}} ตัวอักษร)',
  'form.errors.date.wrongDate': 'ค่าวันที่ที่เลือกไม่ถูกต้อง',
  'bankAccountForm.errors.business_name': 'ชื่อธุรกิจไม่ถูกต้อง',
  'bankAccountForm.errors.business_name.maxSizeExceeded':
    'ชื่อธุรกิจยาวเกินไป (สูงสุด 140 ตัวอักษร)',
  'bankAccountForm.errors.surname': 'นามสกุลไม่ถูกต้อง',
  'bankAccountForm.errors.surname.maxSizeExceeded': 'นามสกุลยาวเกินไป (สูงสุด 140 ตัวอักษร)',
  'bankAccountForm.errors.country': 'ประเทศหรือภูมิภาคไม่ถูกต้อง',
  'bankAccountForm.errors.address': 'ที่อยู่ไม่ถูกต้อง',
  'bankAccountForm.errors.address.maxSizeExceeded': 'ที่อยู่ยาวเกินไป (สูงสุด 256 ตัวอักษร)',
  'bankAccountForm.errors.city': 'เมืองไม่ถูกต้อง',
  'bankAccountForm.errors.city.maxSizeExceeded': 'ชื่อเมืองยาวเกินไป (สูงสุด 256 ตัวอักษร)',
  'bankAccountForm.errors.email': 'อีเมลไม่ถูกต้อง',
  'bankAccountForm.errors.state': 'รัฐไม่ถูกต้อง',
  'bankAccountForm.errors.iban': 'IBAN ไม่ถูกต้อง',
  'bankAccountForm.errors.bic': 'รหัส BIC ไม่ถูกต้อง',
  'bankAccountForm.errors.accountnumber': 'หมายเลขบัญชีไม่ถูกต้อง',
  'bankAccountForm.errors.sortcode': 'Sort code ไม่ถูกต้อง',
  'bankAccountForm.errors.account_type': 'ประเภทบัญชีไม่ถูกต้อง',
  'bankAccountForm.errors.addressIsPoBox': 'เราไม่รับตู้ไปรษณีย์ในช่องที่อยู่',
  'bankAccountForm.errors.onlyLetterOrNumbers': 'ใช้ได้เฉพาะอักขระ A-Z และ 0-9 เท่านั้น',
  'bankAccountForm.errors.onlyLetterOrNumberOrSymbol': 'อักขระที่ใช้ได้ ได้แก่ A-Z 0-9 / , -',
  'bankAccountForm.errors.zip': 'รหัสไปรษณีย์ไม่ถูกต้อง',
  'bankAccountForm.errors.phone': 'หมายเลขโทรศัพท์ไม่ถูกต้อง',
  'bankAccountForm.errors.ach_account_number': 'หมายเลขบัญชีไม่ถูกต้อง',
  'bankAccountForm.errors.routing_number': 'หมายเลข Routing ไม่ถูกต้อง',
  'bankAccountForm.errors.offer':
    'ไม่มีตัวเลือกการชำระเงิน - หากคุณมีบัญชีธนาคารในประเทศ/ภูมิภาคอื่น โปรดเลือกประเทศ/ภูมิภาคนั้น หรือเลือกบัตรใบอื่นแล้วลองอีกครั้ง หากยังไม่สามารถแก้ไขปัญหาได้ โปรดติดต่อ {{recipientName}}',
  'binLookUp.unableToFindCard.message':
    'บัตรมีข้อผิดพลาด โปรดตรวจสอบรายละเอียดบัตรที่กรอก หรือลองใช้บัตรใบอื่น',
  'binLookUp.warning.message': 'เราไม่สามารถตรวจสอบบัตรของคุณได้',
  'confirmationPage.labels.edit': 'แก้ไข',
  'confirmationPage.labels.confirm': 'ยืนยัน',
  'confirmationPage.labels.title': 'ตรวจสอบข้อมูลคำสั่งหักบัญชี',
  'confirmationPage.labels.typeOfPayment': 'ประเภทการชำระเงิน',
  'confirmationPage.labels.paymentRecipient': 'ผู้รับชำระเงิน',
  'confirmationPage.labels.typeOfPayment.oneOff': 'ครั้งเดียว',
  'confirmationPage.labels.typeOfPayment.recurring': 'ประจำ',
  'confirmationPage.labels.directDebitInformation': 'ข้อมูลการหักบัญชีโดยตรง',
  'confirmationPage.labels.directDebitInformation.title': 'คำสั่งถึงธนาคารของคุณ',
  'confirmationPage.labels.directDebitInformation.creditor': 'เจ้าหนี้',
  'confirmationPage.labels.directDebitInformation.creditorId': 'รหัสเจ้าหนี้',
  'confirmationPage.labels.directDebitInformation.serviceUserStatement': 'ชื่อในใบแจ้งยอดของคุณ',
  'confirmationPage.labels.directDebitInformation.serviceUserId': 'รหัสผู้ใช้บริการ',
  'confirmationPage.labels.directDebitInformation.address': 'ที่อยู่ของ Flywire',
  'confirmationPage.labels.directDebitInformation.originator': 'ผู้ริเริ่มรายการ',
  'confirmationPage.labels.directDebitInformation.originatorId': 'รหัสผู้ริเริ่มรายการ',
  'confirmationPage.labels.directDebitInformation.originatorAddress': 'ที่อยู่ของผู้ริเริ่มรายการ',
  'confirmationPage.labels.bankAccountInformation': 'ข้อมูลบัญชีธนาคาร',
  'confirmationPage.labels.bankAccountInformation.name': 'ชื่อ',
  'confirmationPage.labels.bankAccountInformation.iban': 'หมายเลข IBAN',
  'confirmationPage.labels.bankAccountInformation.email': 'อีเมล',
  'confirmationPage.labels.bankAccountInformation.country': 'ประเทศหรือภูมิภาค',
  'confirmationPage.labels.bankAccountInformation.state': 'รัฐ',
  'confirmationPage.labels.bankAccountInformation.city': 'เมือง',
  'confirmationPage.labels.bankAccountInformation.bicCode': 'รหัส BIC',
  'confirmationPage.labels.bankAccountInformation.accountNumber': 'หมายเลขบัญชี',
  'confirmationPage.labels.bankAccountInformation.sortCode': 'Sort code',
  'confirmationPage.labels.bankAccountInformation.achAccountNumber': 'หมายเลขบัญชี',
  'confirmationPage.labels.bankAccountInformation.routingNumber': 'หมายเลข Routing',
  'confirmationPage.labels.bankAccountInformation.accountType': 'ประเภทบัญชี',
  'confirmationPage.labels.paymentInformation': 'ข้อมูลการชำระเงิน',
  'confirmationPage.labels.paymentInformation.amount': 'จำนวนเงิน',
  'confirmationPage.labels.changeAccountEft': 'เปลี่ยนรายละเอียดบัญชีธนาคาร',
  'confirmationPage.labels.editPayerEft': 'แก้ไขรายละเอียดผู้ชำระเงิน',
  'confirmationPage.labels.useAccountEft': 'ใช้บัญชีที่ลงท้ายด้วย **** {{lastFour}}',
  'confirmationPage.labels.bankLinkSuccessMessage': 'เชื่อมต่อบัญชีธนาคารสำเร็จ',
  'confirmationPage.labels.termsSepa':
    'การลงนามในแบบฟอร์มคำสั่งหักบัญชีนี้ถือว่าคุณอนุญาตให้ (ก) FLYWIRE EUROPE UAB ส่งคำสั่งไปยังธนาคารของคุณเพื่อหักเงินจากบัญชีของคุณ และ (ข) ธนาคารของคุณหักเงินจากบัญชีของคุณตามคำสั่งของ FLYWIRE EUROPE UAB คุณจะได้รับแจ้งล่วงหน้าอย่างน้อย 3 วันก่อนที่จะมีการเรียกเก็บเงิน',
  'confirmationPage.labels.termsBacs':
    'สั่งให้ธนาคารของคุณชำระเงินหักบัญชีโดยตรงให้ Flywire Payments Limited จากบัญชีที่ระบุในคำสั่งนี้ ภายใต้การคุ้มครองตามหลักประกันการหักบัญชีโดยตรง (Direct Debit Guarantee) ฉันเข้าใจว่าคำสั่งนี้อาจถูกเก็บไว้ที่ Flywire Payments Limited และหากเป็นเช่นนั้น รายละเอียดจะถูกส่งทางอิเล็กทรอนิกส์ไปยังธนาคาร/สมาคมอาคารสงเคราะห์ของฉัน',
  'confirmationPage.labels.termsAch':
    '\n     เมื่อคลิก "ยืนยัน" คุณรับรองว่าคุณมีอำนาจที่เหมาะสม และอนุญาตให้ Flywire ในนามของผู้รับชำระเงินที่ระบุ\n     ("ผู้รับชำระเงิน") หักเงินจากบัญชีธนาคารที่คุณให้ไว้สำหรับจำนวนเงินใดๆ ที่ค้างชำระจากการใช้บริการของผู้รับชำระเงิน\n     และ/หรือการซื้อผลิตภัณฑ์จากผู้รับชำระเงิน และหากจำเป็น ให้แก้ไขรายการหักเงินที่ผิดพลาดตามข้อกำหนดของผู้รับชำระเงิน จนกว่าการอนุญาตนี้\n     จะถูกเพิกถอน ในกรณีที่รายการ ACH ถูกปฏิเสธเนื่องจากเงินไม่เพียงพอ ฉันเข้าใจว่าฉันจะถูกเรียกเก็บ\n     ค่าธรรมเนียม NSF และ Flywire อาจพิจารณาดำเนินการเรียกเก็บเงินอีกครั้งตามดุลยพินิจของตน\n     ',
  'confirmationPage.labels.termsAch2':
    '\n     หากคุณใช้หรือซื้อผลิตภัณฑ์และ/หรือบริการเพิ่มเติมของผู้รับชำระเงินเป็นระยะ ตามข้อกำหนดของผู้รับชำระเงิน คุณอนุญาตให้\n     Flywire ในนามของผู้รับชำระเงิน หักเงินจากบัญชีธนาคารที่คุณให้ไว้เป็นระยะ การชำระเงินที่อยู่นอกเหนือจากการหักเงิน\n     ที่ได้รับอนุญาตข้างต้นจะถูกหักก็ต่อเมื่อได้รับการอนุญาตจากคุณผ่านบัญชีของคุณ หรือผ่านรหัสผ่าน รหัส หรือ\n     ลายเซ็นที่มีผลเทียบเท่า\n     ',
  'confirmationPage.labels.termsAch3':
    '\n     คุณสามารถเพิกถอนการอนุญาตนี้ได้ทุกเมื่อโดยติดต่อผู้รับชำระเงิน การเพิกถอนของคุณต้องได้รับอย่างน้อย [10 วันทำการ]\n     ก่อนการชำระเงินครั้งถัดไปตามกำหนด\n    ',
  'confirmationPage.labels.print': 'พิมพ์ข้อตกลง',
  'amountPanel.labels.amountFromLabel': 'คุณจะชำระ',
  'amountPanel.labels.surchargeFeeInfo': 'รวมค่าธรรมเนียมบัตรแล้ว',
  'amountPanel.labels.serviceFeeInfo': 'รวมค่าธรรมเนียมบริการแล้ว',
  'amountPanel.labels.serviceFeePercentageInfo':
    'ค่าธรรมเนียมบริการ {{percentage}} (ขั้นต่ำ {{minimumFee}})',
  'amountPanel.labels.serviceFeePercentageOnlyInfo': 'ค่าธรรมเนียมบริการ {{percentage}}',
  'amountPanel.labels.whyThisFee': 'เหตุใดจึงมีค่าธรรมเนียมนี้',
  'amountPanel.labels.currencyChangeWarning': 'สกุลเงินถูกเปลี่ยนให้ตรงกับสกุลเงินของบัตรของคุณ',
  'amountPanel.labels.amountToLabel': '{{recipientName}} จะได้รับ',
  'amountPanel.labels.editCurrencySelection': 'แก้ไขการเลือกสกุลเงิน',
  'amountPanel.labels.discountApplied': 'ใช้ส่วนลด {{amount}} แล้ว',
  'currencyInfoBanner.labels.currencyInfo':
    'การชำระเงินครั้งต่อไปของคุณจะถูกเรียกเก็บเป็น <b>{{code}} ({{symbol}})</b>',
  'currencyInfoBanner.error.offerNotFound': 'ไม่มีตัวเลือกการชำระเงิน',
  AX: 'หมู่เกาะโอลันด์',
  AD: 'อันดอร์รา',
  BG: 'บัลแกเรีย',
  AT: 'ออสเตรีย',
  BE: 'เบลเยียม',
  HR: 'โครเอเชีย',
  CY: 'ไซปรัส',
  CZ: 'เช็ก',
  DK: 'เดนมาร์ก',
  EE: 'เอสโตเนีย',
  FI: 'ฟินแลนด์',
  FR: 'ฝรั่งเศส',
  GP: 'กวาเดอลูป',
  DE: 'เยอรมนี',
  GR: 'กรีซ',
  HU: 'ฮังการี',
  IS: 'ไอซ์แลนด์',
  IE: 'ไอร์แลนด์',
  VA: 'นครวาติกัน',
  IT: 'อิตาลี',
  LI: 'ลิกเตนสไตน์',
  LT: 'ลิทัวเนีย',
  LU: 'ลักเซมเบิร์ก',
  YT: 'มายอต',
  MT: 'มอลตา',
  MQ: 'มาร์ตินีก',
  ES: 'สเปน',
  NO: 'นอร์เวย์',
  NL: 'เนเธอร์แลนด์',
  PL: 'โปแลนด์',
  PT: 'โปรตุเกส',
  SE: 'สวีเดน',
  RE: 'เรอูนียง',
  RO: 'โรมาเนีย',
  CH: 'สวิตเซอร์แลนด์',
  BL: 'เซนต์บาร์เธเลมี',
  GB: 'สหราชอาณาจักร',
  MC: 'โมนาโก',
  MF: 'เซนต์มาร์ติน',
  PM: 'แซงปีแยร์และมีเกอลง',
  SM: 'ซานมาริโน',
  SK: 'สโลวะเกีย',
  SI: 'สโลวีเนีย',
  GF: 'เฟรนช์เกียนา',
  LV: 'ลัตเวีย',
  CA: 'แคนาดา',
  US: 'สหรัฐอเมริกา',
  'inlineDialogConfirmation.labels.title': 'ต้องยืนยัน: ยกเลิกขั้นตอน',
  'inlineDialogConfirmation.labels.body': 'คุณแน่ใจหรือไม่ว่าต้องการยกเลิกขั้นตอนนี้',
  'inlineDialogConfirmation.labels.closeButton': 'ไม่',
  'inlineDialogConfirmation.labels.confirmButton': 'ใช่',
  'priceBreakDown.price.toggle.button': 'รายละเอียดราคา',
  'priceBreakDown.fx.toggle.button': 'รายละเอียดอัตราแลกเปลี่ยน',
  'priceBreakDown.fees': 'ค่าธรรมเนียม',
  'priceBreakDown.service_fees': 'ค่าธรรมเนียมบริการ',
  'priceBreakDown.card_fees': 'ค่าธรรมเนียมบัตร',
  'priceBreakDown.exchange.rate': 'อัตราแลกเปลี่ยน',
  'priceBreakDown.markup.rate': 'ส่วนต่างจากอัตรา ECB',
  'priceBreakDown.discount': 'ส่วนลด',
  'priceBreakDown.discount.coupon': 'ส่วนลด ({{code}})',
  'priceBreakDown.original_amount': 'จำนวนเงินเดิม',
  'priceBreakDown.total': 'ยอดรวม',
  'acceptProposedOfferBanner.textInfo':
    "บัตรนี้ไม่มีสิทธิ์ใช้งาน แตะ 'ยอมรับ' เพื่อดำเนินการต่อด้วยวิธีการชำระเงินที่รองรับ หรือ ",
  'acceptProposedOfferBanner.textInfoWithoutChangeCard':
    "บัตรนี้ไม่มีสิทธิ์ใช้งาน แตะ 'ยอมรับ' เพื่อดำเนินการต่อด้วยวิธีการชำระเงินที่รองรับ",
  'acceptProposedOfferBanner.link.option': 'เปลี่ยนบัตร',
  'acceptProposedOfferBanner.labels.accept': 'ยอมรับ',
  'chooseCurrencyBanner.title': 'เลือกสกุลเงิน',
  'chooseCurrencyBanner.message':
    'สกุลเงินของบัตรแตกต่างจากสกุลเงินของประเทศที่ใช้เรียกเก็บเงิน โปรดเลือกสกุลเงินที่ต้องการใช้สำหรับธุรกรรมนี้:',
  'banner.offer.validation.message': 'คุณต้องเลือกการดำเนินการเพื่อดำเนินการต่อ',
  'instructions.offline.amount.label': 'จำนวนเงินที่ต้องชำระ',
  'instructions.offline.reference.label': 'เลขอ้างอิง / รหัสการชำระเงิน',
  'instructions.offline.paymentId.label': 'รหัสการชำระเงิน',
  'instructions.offline.paymentReferenceMissing': 'ไม่พบเลขอ้างอิงการชำระเงิน',
  'instructions.offline.missing.title': 'ไม่สามารถสร้างคำแนะนำการชำระเงินของคุณได้',
  'instructions.offline.missing.message':
    'โปรดลองอีกครั้ง หากปัญหายังคงอยู่ โปรดลองใช้วิธีการชำระเงินอื่นหรือติดต่อธนาคารของคุณ',
  'instructions.offline.title': 'คำแนะนำการชำระเงิน',
  'instructions.offline.understand':
    'ฉันเข้าใจว่าต้องทำรายการโอนเงินจากธนาคารของฉันเอง<br />คลิกที่นี่เพื่อปิด',
  'instructions.offline.download.button': 'ดาวน์โหลดคำแนะนำการโอนเงินผ่านธนาคาร',
  'instructions.offline.howToBankTransfer': 'โอนเงินผ่านธนาคารทำอย่างไร',
  'instructions.offline.howToBankTransfer.modal.title':
    'วิธีทำรายการโอนเงินผ่านธนาคารให้เสร็จสมบูรณ์',
  'instructions.offline.howToBankTransfer.modal.intro':
    'ด้านล่างนี้คือตัวเลือกต่างๆ ที่คุณใช้ทำรายการโอนเงินผ่านธนาคารให้เสร็จสมบูรณ์ได้:',
  'instructions.offline.howToBankTransfer.modal.onlineBankingTitle':
    'ธนาคารออนไลน์ / โมบายแบงก์กิ้ง',
  'instructions.offline.howToBankTransfer.modal.onlineBankingDescription':
    'หากคุณใช้ธนาคารออนไลน์หรือแอปของธนาคาร คุณสามารถเข้าสู่ระบบบัญชีและทำรายการโอนเงินด้วยตนเองได้โดยง่าย',
  'instructions.offline.howToBankTransfer.modal.inPersonTitle': 'ไปที่สาขาธนาคารด้วยตนเอง',
  'instructions.offline.howToBankTransfer.modal.inPersonDescription':
    'คุณสามารถไปที่สาขาธนาคารในพื้นที่ของคุณด้วยตนเอง และแจ้งรายละเอียดบัญชีที่จำเป็นซึ่งอยู่ในคำแนะนำการชำระเงินแก่ธนาคารเพื่อทำรายการโอนเงิน',
  'instructions.offline.howToBankTransfer.modal.telephoneTitle': 'โอนเงินทางโทรศัพท์',
  'instructions.offline.howToBankTransfer.modal.telephoneDescription':
    'คุณยังสามารถโทรหาธนาคารและอนุญาตให้ธนาคารทำรายการแทนคุณได้',
  'instructions.offline.referenceWarning':
    'คุณต้องระบุเลขอ้างอิงนี้เพื่อให้เราระบุการชำระเงินของคุณได้',
  'instructions.offline.dueDateLabel': 'โอนเงินก่อนวันที่:',
  'instructions.offline.processingTime':
    'Flywire จะได้รับเงินภายใน <strong>2-3 วันทำการ</strong> หลังจากคุณทำรายการโอนเงิน',
  'elementsInstructions.qr.description': 'สแกนคิวอาร์โค้ดเพื่อชำระเงินให้เสร็จสมบูรณ์',
  'elementsInstructions.qr.payid.description':
    'เปิดแอปธนาคารของคุณและโอนไปยัง PayID ด้านล่าง ที่อยู่นี้กำหนดไว้สำหรับบัญชีของคุณโดยเฉพาะ การชำระเงินจะถูกจับคู่โดยอัตโนมัติ',
  'elementsInstructions.qr.scan': 'หรือสแกนด้วยกล้องโทรศัพท์ของคุณ',
  'elementsInstructions.qr.waitingForPayment': 'กำลังรอการชำระเงินเสร็จสมบูรณ์',
  'elementsInstructions.externalAction.generic': 'โปรดชำระเงินให้เสร็จสมบูรณ์เพื่อดำเนินการต่อ',
  'elementsInstructions.externalAction.mpesa_message_finish_payment_on_phone':
    'ส่งคำขอชำระเงิน M-Pesa ไปยังโทรศัพท์ของคุณแล้ว\nโปรดชำระเงินให้เสร็จสมบูรณ์เพื่อดำเนินการต่อ',
  'elementsInstructions.redirect.title': 'ชำระเงินให้เสร็จสมบูรณ์',
  'elementsInstructions.redirect.description':
    'คุณจะถูกนำไปยังแพลตฟอร์มประมวลผลของพันธมิตรเพื่อทำการชำระเงินนี้ให้เสร็จสมบูรณ์ เมื่อเสร็จแล้วคุณจะถูกเปลี่ยนเส้นทางกลับมายังหน้านี้อีกครั้ง',
  'elementsInstructions.redirect.button': 'ชำระเงิน',
  'documentCollector.collapsibleTitle': 'อัปโหลดเอกสาร',
  'documentCollector.uploadingDocument': 'กำลังอัปโหลดเอกสาร',
  'documentCollector.deleteFile': 'ลบ {{fileName}}',
  'documentCollector.deletingFile': 'กำลังลบ {{fileName}}',
  'documentCollector.moreInfoModal': 'ข้อมูลเพิ่มเติม',
  'documentCollector.errorsModal': 'ข้อผิดพลาดของเอกสาร',
  'documentCollector.documentList': 'รายการเอกสาร',
  'documentCollector.upload': 'อัปโหลด',
  'documentCollector.errorBlockLabel': 'ข้อผิดพลาดของเอกสาร',
  'documentCollector.reUpload': 'อัปโหลดอีกครั้ง',
  'documentCollector.errorsFoundOne': 'พบข้อผิดพลาด {{count}} รายการ',
  'documentCollector.errorsFoundOther': 'พบข้อผิดพลาด {{count}} รายการ',
  'documentCollector.validationNote':
    '<b>อัปโหลดไฟล์เสร็จสมบูรณ์</b> การสแกนอัตโนมัติของเราพบปัญหาที่อาจเกิดขึ้น หากเอกสารของคุณมีข้อมูลที่จำเป็นครบถ้วน โปรดละเว้นคำเตือนนี้',
  'documentCollector.antivirus': 'การสแกนไฟล์ด้วยแอนติไวรัส',
  'documentCollector.antivirusStep': 'การสแกนไฟล์ด้วยแอนติไวรัส 1/2',
  'documentCollector.verifyingStep': 'กำลังตรวจสอบเอกสาร 2/2',
  'documentCollector.invalidFile':
    'พบไฟล์ที่ไม่ถูกต้อง ไฟล์อาจมีการป้องกันด้วยรหัสผ่านหรือถูกเข้ารหัส โปรดตรวจสอบแล้วลองอีกครั้ง',
  'documentCollector.moreInfo': 'ข้อมูลเพิ่มเติม',
  'documentCollector.required': 'จำเป็น',
  'documentCollector.review': 'ตรวจสอบ',
  'documentCollector.acceptedFileTypes': 'ประเภทไฟล์ที่รองรับ: <b>PDF</b>, <b>PNG</b>, <b>JPG</b>',
  'documentCollector.maxFileSize': 'ขนาดไฟล์สูงสุด: <b>{{maxFileSize}}MB</b>',
  'documentCollector.acceptedFileAndFileSize':
    'ประเภทไฟล์ที่รองรับ: <b>PDF</b>, <b>PNG</b>, <b>JPG</b> ขนาดไฟล์สูงสุด: <b>{{maxFileSize}}MB</b>',
  'documentCollector.docVerifyError.missingInfo': 'โปรดตรวจสอบว่าเอกสารมีข้อมูลที่ร้องขอครบถ้วน',
  'documentCollector.docVerifyError.documentTypeError':
    'เอกสารนี้ดูเหมือนจะไม่ใช่ {{documentType}} โปรดตรวจสอบข้อกำหนดและอัปโหลดไฟล์ใหม่หากจำเป็น',
  'documentCollector.docVerifyError.documentIdentificationTypeError':
    'เอกสารที่อัปโหลดดูเหมือนจะไม่ใช่ {{documentType}} ซึ่งเป็นประเภทการยืนยันตัวตนที่คุณเลือกสำหรับการชำระเงินนี้ โปรดตรวจสอบและอัปโหลดอีกครั้งหากจำเป็น',
  'documentCollector.docVerifyError.documentType.errorNote':
    '<b>หมายเหตุ</b>: การส่งเอกสารที่ไม่ถูกต้องอาจทำให้การดำเนินการชำระเงินล่าช้า หากเอกสารของคุณถูกต้อง โปรดละเว้นหมายเหตุเตือนนี้',
  'documentCollector.duplicateFile': 'พบเอกสารซ้ำ โปรดอัปโหลดไฟล์ที่แตกต่างกันสำหรับแต่ละรายการ',
  'oneOff.savePaymentMethod.label': 'บันทึกวิธีการชำระเงินนี้สำหรับการชำระเงินครั้งต่อไป',
  'lrs.transaction.title': 'ธุรกรรม',
  'lrs.transaction.date': 'วันที่',
  'lrs.transaction.amount': 'จำนวนเงิน',
  'lrs.transaction.amountHint': 'จำนวนเงินในสกุลเงินต่างประเทศ',
  'lrs.transaction.adBranch': 'ชื่อและที่อยู่ของสาขา AD',
  'lrs.transaction.add': 'เพิ่มธุรกรรม',
  'lrs.signatureModal.title': 'ลงนามในเอกสาร',
  'lrs.signatureModal.tab.draw': 'วาดลายเซ็น',
  'lrs.signatureModal.tab.upload': 'อัปโหลดลายเซ็น',
  'lrs.signatureModal.draw.text':
    'ลงนามในช่องว่างด้านล่างโดยใช้เมาส์หรือนิ้วของคุณเพื่อยอมรับเอกสาร',
  'lrs.signatureModal.legalAlert':
    'ลายเซ็นที่ไม่ถูกต้องจะทำให้กระบวนการ LRS ทั้งหมดเป็นโมฆะ โปรดตรวจสอบให้แน่ใจว่าลงนามด้วย<b>ลายเซ็นของผู้ถือ PAN</b> สำเนาเอกสารจะถูกส่งไปยังอีเมลของผู้ชำระเงินที่ให้ไว้เพื่อใช้อ้างอิงในอนาคต ประเภทไฟล์ที่รองรับ: <b>PNG</b>, <b>JPG</b>',
  'lrs.signatureModal.draw.clear': 'ล้าง',
  'lrs.signatureModal.upload.label': 'อัปโหลดลายเซ็นของคุณเป็นไฟล์รูปภาพ',
  'lrs.signatureModal.upload.input': 'อัปโหลดลายเซ็น',
  'lrs.signatureModal.upload.remove': 'ลบ',
  'lrs.signatureModal.upload.hint':
    'ประเภทไฟล์ที่รองรับ: <b>PNG</b>, <b>JPG</b> ขนาดไฟล์สูงสุด: <b>8MB</b>',
  'lrs.signatureModal.upload.typeError': 'ไม่รองรับประเภทไฟล์นี้ โปรดอัปโหลดไฟล์ PNG หรือ JPG',
  'lrs.signatureModal.upload.sizeError': 'ไฟล์ต้องมีขนาดเล็กกว่า 8MB',
  'lrs.signatureModal.upload.readError': 'ไม่สามารถอ่านไฟล์ได้ โปรดลองอีกครั้ง',
  'lrs.signatureModal.confirm': 'ยอมรับและส่ง',
  'lrs.signatureModal.previewError': 'เกิดข้อผิดพลาดขณะสร้างตัวอย่าง โปรดลองอีกครั้ง',
  'lrs.signatureModal.uploadError': 'เกิดข้อผิดพลาดขณะส่ง โปรดลองอีกครั้ง',
  'lrs.previewLink.label': 'ดูตัวอย่างเอกสาร',
  'lrs.documents.continueButton': 'ดำเนินการต่อเพื่อส่งแบบฟอร์ม LRS',
  'lrs.form.declaration':
    "ภายใต้โครงการ Liberalised Remittance Scheme (LRS) รัฐบาลอินเดียและธนาคารกลางอินเดีย (RBI) กำหนดให้ต้องมีแบบฟอร์มคำแถลง LRS (ชื่อเต็มคือ \"A2 cum LRS Declaration\") เพื่อโอนเงินไปต่างประเทศ จำเป็นต้องส่งคำแถลง LRS ก่อนเริ่มทำรายการโอนเงินผ่านธนาคาร มิฉะนั้นการชำระเงินของคุณอาจล่าช้า สำหรับรายละเอียดเพิ่มเติมเกี่ยวกับวิธีดำเนินการขั้นตอนนี้ คลิก <a href='https://help.flywire.com/hc/en-us/articles/360012963774' target='_blank'>ที่นี่</a> เพื่อดูข้อมูลเพิ่มเติม",
  'lrs.form.bankAccountAndStudentInfo.title': 'ข้อมูลบัญชีธนาคารและนักเรียน',
  'lrs.form.bankAccountAndStudentInfo.text':
    'โปรดระบุบัญชีธนาคารที่จะใช้โอนเงิน หากคุณกู้ยืมเพื่อการศึกษาและเงินจะถูกเบิกจากบัญชีเงินกู้ของคุณ โปรดระบุหมายเลขบัญชีเงินกู้ ไม่รับการโอนจากบัญชี NRO/NRE สำหรับรหัสนักเรียน คุณสามารถใช้รหัสนักเรียน รหัสใบสมัคร หรือหมายเลขอ้างอิงได้',
  'lrs.form.details.title': 'รายละเอียดธุรกรรมระหว่างประเทศที่ทำในปีงบประมาณปัจจุบัน',
  'lrs.form.details.text':
    'โปรดระบุรายละเอียดธุรกรรมสกุลเงินต่างประเทศที่คุณทำในปีงบประมาณปัจจุบัน (<b>เมษายน {{startYear}} - มีนาคม {{endYear}}</b>) หากไม่เคยทำ ให้เว้นว่างไว้',
  'lrs.form.bankAccountNumber': 'หมายเลขบัญชีธนาคาร',
  'lrs.form.studentFullName': 'ชื่อ-นามสกุลของนักเรียน',
  'lrs.form.studentId': 'รหัสนักเรียน',
  'lrs.form.required': 'จำเป็น',
  'lrs.form.signAndSubmit': 'ลงนามและส่งแบบฟอร์ม LRS',
  'lrs.title': 'อัปโหลดเอกสารและส่งแบบฟอร์ม LRS',
  'lrs.description': 'คุณจะเห็นคำแนะนำการโอนเงินผ่านธนาคารเมื่อดำเนินการขั้นตอนนี้เสร็จสิ้น',
  'lrs.tabs.documents': '1. อัปโหลดเอกสาร',
  'lrs.tabs.form': '2. ส่งแบบฟอร์ม LRS',
  'recipientFields.requiredField': '(*) จำเป็นต้องกรอก',
  'paymentMethodSelector.loading': 'กำลังโหลดวิธีการชำระเงิน...',
  'paymentMethodSelector.cards.acceptsDebitAndCredit': 'รองรับบัตรเดบิตและบัตรเครดิต',
  'paymentMethodSelector.cards.acceptsDebitOnly': 'รองรับบัตรเดบิต',
  'paymentMethodSelector.cards.acceptsCreditOnly': 'รองรับบัตรเครดิต',
  'paymentMethodSelector.cards.surchargeWarning':
    'อาจมีค่าธรรมเนียมเพิ่มเติมขึ้นอยู่กับประเภทบัตรและประเทศของผู้ออกบัตร',
  'paymentMethodSelector.subtitle.default': 'ชำระเงินด้วย {{methodName}}',
  'paymentMethodSelector.subtitle.google_pay': 'ชำระเงินด้วยกระเป๋า Google Pay ที่บันทึกไว้',
  'paymentMethodSelector.subtitle.apple_pay': 'Touch ID หรือ Face ID — ใช้ได้เฉพาะ Safari',
  'paymentMethodSelector.subtitle.paypal': 'ชำระเงินด้วยบัญชี PayPal ของคุณ',
  'paymentMethodSelector.subtitle.wechat': 'ชำระเงินด้วย WeChat — ใช้ได้ในจีนแผ่นดินใหญ่',
  'paymentMethodSelector.subtitle.alipay': 'ชำระเงินด้วย Alipay',
  'paymentMethodSelector.subtitle.trustly': 'การชำระเงินผ่านโอเพนแบงก์กิ้ง'
} as const;
export { thTH };
